// extracted by mini-css-extract-plugin
export var infoRow = "_u9-2";
export var labelContainer = "_u9-0";
export var rightInfo = "_u9-1";